import React from 'react';
import { Check, ArrowRight, Star } from 'lucide-react';
import { TrustBadge } from '../components/TrustBadge';
import { WebinarForm } from '../components/WebinarForm';
export function WebinarOptIn() {
  const scrollToForm = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <main className="min-h-screen bg-[#FAFAF7] text-[#2D2D2D] font-sans selection:bg-[#7CAA98] selection:text-white" data-id="element-9">
      <div className="max-w-6xl mx-auto px-4 py-8 md:py-16" data-id="element-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start" data-id="element-11">
          {/* Left Content Column */}
          <div className="lg:col-span-7 flex flex-col" data-id="element-12">
            {/* Hero Section */}
            <div className="mb-8" data-id="element-13">
              <TrustBadge data-id="element-14" />
              <h1 className="text-3xl md:text-5xl font-bold leading-tight mb-6 text-[#1A1A1A]" data-id="element-15">
                Ontdek waarom jouw hond uitvalt – en hoe je dit stap voor stap
                oplost
              </h1>
              <p className="text-lg md:text-xl text-gray-700 leading-relaxed font-medium" data-id="element-16">
                Gratis webinar: Leer de 6-fasen methode waarmee al 15.000+
                hondenbezitters uitvalgedrag bij de kern aanpakten. Zonder
                straffen. Zonder dwang.
              </p>
            </div>

            {/* Mobile Form (Visible only on mobile/tablet) */}
            <div className="lg:hidden mb-12" data-id="element-17">
              <WebinarForm data-id="element-18" />
            </div>

            {/* Benefits Section */}
            <section className="mb-16" data-id="element-19">
              <h2 className="text-2xl font-bold mb-8 text-[#1A1A1A]" data-id="element-20">
                In dit gratis webinar leer je:
              </h2>
              <ul className="space-y-6" data-id="element-21">
                {['Waarom je hond uitvalt (hint: het is geen agressie en geen dominantie – het is een noodkreet)', 'Het "emmer-principe" dat verklaart waarom sommige dagen erger zijn dan andere – en hoe je dit doorbreekt', 'Hoe je een uitval kunt zien aankomen, zodat je kunt ingrijpen vóórdat het te laat is', 'Welke goedbedoelde aanpakken uitvalgedrag juist in stand houden (en het probleem ongemerkt erger maken)', 'De eerste onmisbare stap die je moet nemen – voor iedere vorm van uitvalgedrag', 'De 6-fasen methode waarmee wij uitvallen aan de lijn echt, en in de kern, oplossen'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-22">
                    <div className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#E8F3EF] flex items-center justify-center" data-id="element-23">
                      <Check className="w-4 h-4 text-[#7CAA98]" strokeWidth={3} data-id="element-24" />
                    </div>
                    <span className="text-base md:text-lg text-gray-800 leading-relaxed" data-id="element-25">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </section>

            {/* "For You" Section */}
            <section className="mb-16 bg-white p-8 rounded-2xl border border-[#E6E6E0] shadow-sm" data-id="element-26">
              <h2 className="text-2xl font-bold mb-6 text-[#1A1A1A]" data-id="element-27">
                Dit webinar is voor jou als:
              </h2>
              <ul className="space-y-4" data-id="element-28">
                {['Je wandelingen voelen als een overlevingsmissie in plaats van ontspanning', 'Je al van alles hebt geprobeerd maar niets écht werkt', 'Je van je hond houdt, maar soms stiekem denkt: "Kan ik dit nog wel aan?"', 'Je wilt begrijpen waarom je hond zo reageert – zonder hem te hoeven straffen'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-29">
                    <ArrowRight className="w-5 h-5 text-[#C4896B] mt-1 flex-shrink-0" data-id="element-30" />
                    <span className="text-gray-700 text-lg" data-id="element-31">{item}</span>
                  </li>)}
              </ul>
            </section>

            {/* About Section */}
            <section className="mb-12 flex flex-col md:flex-row gap-8 items-start" data-id="element-32">
              <div className="flex-shrink-0" data-id="element-33">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-white shadow-md bg-gray-200" data-id="element-34">
                  <img src="https://cdn.magicpatterns.com/uploads/fsBaXJdL7x3R8CWaHGZ3YP/Ontwerp_zonder_titel_(13).jpg" alt="Amee de Bruijn" className="w-full h-full object-cover" data-id="element-35" />
                </div>
              </div>
              <div data-id="element-36">
                <h3 className="text-xl font-bold mb-3 text-[#1A1A1A]" data-id="element-37">
                  Over Amee de Bruijn
                </h3>
                <div className="space-y-4 text-gray-700 leading-relaxed" data-id="element-38">
                  <p data-id="element-39">
                    Als hondengedragsdeskundige is het welzijn van een hond én
                    zijn mens het allerbelangrijkste. Daarom werk ik uitsluitend
                    met methodes vrij van dwang, pijn en straf.
                  </p>
                  <p data-id="element-40">
                    Ik ben gediplomeerd hondengedragsconsultant en Natural Dog
                    Trainer, en heb inmiddels meer dan 15.000 baasjes en hun
                    honden mogen helpen. Niet door harder te corrigeren, maar
                    door te begrijpen wat er écht aan de hand is.
                  </p>
                  <p className="font-medium text-[#7CAA98]" data-id="element-41">
                    Ik kan niet wachten om mijn kennis ook met jou te delen.
                  </p>
                </div>

                <div className="mt-6 flex flex-wrap gap-2" data-id="element-42">
                  {['Gediplomeerd hondengedragsconsultant', 'Natural Dog Trainer', '15.000+ honden geholpen'].map((cred, i) => <span key={i} className="inline-block px-3 py-1 bg-[#F5F5F0] text-xs font-medium text-gray-600 rounded-md" data-id="element-43">
                      {cred}
                    </span>)}
                </div>
              </div>
            </section>

            {/* Final CTA (Mobile/Tablet only - Desktop has sticky form) */}
            <div className="block lg:hidden text-center bg-[#2D4A3E] text-white p-8 rounded-xl" data-id="element-44">
              <h3 className="text-xl font-bold mb-4" data-id="element-45">
                Klaar om te begrijpen waarom jouw hond uitvalt?
              </h3>
              <button onClick={scrollToForm} className="w-full bg-[#7CAA98] hover:bg-[#6B9987] text-white font-bold py-4 px-6 rounded-lg transition-colors shadow-lg text-lg mb-3" data-id="element-46">
                Meld je gratis aan ↑
              </button>
              <p className="text-sm text-gray-300" data-id="element-47">
                Gratis. 90 minuten. Meerdere tijdstippen beschikbaar.
              </p>
            </div>
          </div>

          {/* Right Column - Sticky Form (Desktop Only) */}
          <div className="hidden lg:block lg:col-span-5 relative h-full" data-id="element-48">
            <div className="sticky top-8" data-id="element-49">
              <WebinarForm data-id="element-50" />

              {/* Additional trust elements below form */}
              <div className="mt-6 flex items-center justify-center gap-2 text-gray-500 text-sm" data-id="element-51">
                <div className="flex" data-id="element-52">
                  {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-[#C4896B] fill-current" data-id="element-53" />)}
                </div>
                <span data-id="element-54">4.9/5 uit 2.500+ reviews</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}